/**
 * SASE-30b (P30a2-F3): the pages the SASE edition serves. P30a-2 pruned the menu,
 * but a typed or bookmarked URL still opened a cloud page whose calls then failed;
 * the backend now refuses those calls (404, `EDITION_ROUTE_REFUSED`), and the console
 * says so before it tries. The SASE section, Administration → Points of presence, the
 * account, the licences page, and the two services the SASE section mounts beside
 * their own homes (Private access, Agent gateways, SD-01) stay.
 */
export const SASE_EDITION_PAGES: readonly string[] = [
  "/sase",
  "/points-of-presence",
  "/account",
  "/about",
  "/access",
  "/agent-gateways",
  "/oauth/consent",
];

/** True when the SASE edition serves `pathname` (`/` redirects to `/sase`). */
export function editionServesPath(pathname: string): boolean {
  if (pathname === "/" || pathname === "") return true;
  return SASE_EDITION_PAGES.some((page) => pathname === page || pathname.startsWith(`${page}/`));
}
